export default __webpack_public_path__ + "static/media/Level6.1e20394b.svg";